document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".js-school-search-wrap");
  if (!wrappers.length) return;

  const schoolIndex = Array.isArray(window.SCHOOL_INDEX) ? window.SCHOOL_INDEX : [];
  const allCollections = Array.isArray(window.ALL_COLLECTIONS) ? window.ALL_COLLECTIONS : [];

  const normalize = (value) => (value || "").toString().trim().toLowerCase();

  const dedupe = (items) => {
    const seen = new Set();
    const output = [];

    (Array.isArray(items) ? items : []).forEach((item) => {
      if (!item || !item.url) return;

      const key = item.url.replace(window.location.origin, "").replace(/\/$/, "");

      if (!seen.has(key)) {
        seen.add(key);
        output.push(item);
      }
    });

    return output;
  };

  const highlight = (text, query) => {
    const original = String(text || "");
    const q = String(query || "");
    const index = original.toLowerCase().indexOf(q.toLowerCase());

    if (index !== -1 && q) {
      return (
        original.substring(0, index) +
        "<strong>" +
        original.substring(index, index + q.length) +
        "</strong>" +
        original.substring(index + q.length)
      );
    }

    return original;
  };

  const findSchoolResults = (query) => {
    const q = normalize(query);
    if (!q) return [];

    const groups = [];

    schoolIndex.forEach((school) => {
      const schoolName = normalize(school.name);

      const keywords = (Array.isArray(school.keywords) ? school.keywords : [])
        .map((keyword) => (keyword || "").toString().replace(/\r/g, "").trim())
        .filter(Boolean);

      const collections = dedupe(school.collections);

      const schoolMatches = schoolName.includes(q);
      const keywordMatches = keywords.some((keyword) => normalize(keyword).includes(q));
      const matchedCollections = collections.filter((collection) =>
        normalize(collection.title).includes(q)
      );

      if (schoolMatches || keywordMatches || matchedCollections.length) {
        const items = matchedCollections.length ? matchedCollections : collections;

        if (items.length) {
          groups.push({
            schoolName: school.name,
            items
          });
        }
      }
    });

    return groups;
  };

  const findCollectionResults = (query) => {
    const q = normalize(query);
    if (!q) return [];

    const results = allCollections
      .filter((collection) => collection && collection.title && normalize(collection.title).includes(q))
      .map((collection) => ({
        title: collection.title,
        url: collection.url || `/collections/${collection.handle}`
      }));

    return dedupe(results);
  };

    const goToSearchPage = (query) => {
    if (!query) return;
    window.location.href = `/pages/school-collections-search?q=${encodeURIComponent(query)}`;
    };

  const getTotalSchoolResultCount = (groups) => {
    return groups.reduce((count, group) => {
      return count + (group.items ? group.items.length : 0);
    }, 0);
  };

  wrappers.forEach((wrapper) => {
    const input = wrapper.querySelector(".js-school-search-input");
    const button = wrapper.querySelector(".search-input--btn-new");
    const searchMode = wrapper.dataset.searchMode || "all";

    if (!input) return;

    let activeIndex = -1;

    const clearAutocomplete = () => {
      const container = wrapper.querySelector(".autocomplete-items");
      if (container) container.remove();
    };

    const renderAutocomplete = (query) => {
      clearAutocomplete();

      if (!query) return;

      const container = document.createElement("div");
      container.className = "autocomplete-items";
      input.parentNode.appendChild(container);

      const schoolResults = findSchoolResults(query);

      if (schoolResults.length) {
        schoolResults.forEach((group) => {
          const groupWrapper = document.createElement("div");
          groupWrapper.className = "school-group";

          const label = document.createElement("div");
          label.className = "school-label";
          label.innerHTML = `Showing results for: <strong>${group.schoolName}</strong>`;
          groupWrapper.appendChild(label);

          group.items.forEach((item) => {
            const resultItem = document.createElement("div");
            resultItem.className = "collection-item";
            resultItem.innerHTML = highlight(item.title, query);
            resultItem.addEventListener("click", () => {
              window.location.href = item.url;
            });
            groupWrapper.appendChild(resultItem);
          });

          container.appendChild(groupWrapper);
        });

        return;
      }

      if (searchMode !== "college-only") {
        const collectionResults = findCollectionResults(query);

        if (collectionResults.length) {
          collectionResults.forEach((item) => {
            const resultItem = document.createElement("div");
            resultItem.className = "collection-item";
            resultItem.innerHTML = highlight(item.title, query);
            resultItem.addEventListener("click", () => {
              window.location.href = item.url;
            });
            container.appendChild(resultItem);
          });

          return;
        }
      }

      const empty = document.createElement("div");
      empty.className = "is-empty";
      empty.innerHTML = `No matching results for: <strong>${query}</strong>`;
      container.appendChild(empty);
    };

    const handleSearchSubmit = (query) => {
      query = query.trim();
      if (!query) return;

      const schoolResults = findSchoolResults(query);

      if (schoolResults.length) {
        const totalResults = getTotalSchoolResultCount(schoolResults);

        if (totalResults === 1) {
          const first = schoolResults[0]?.items?.[0];
          if (first?.url) {
            window.location.href = first.url;
            return;
          }
        }

        goToSearchPage(query);
        return;
      }

      if (searchMode !== "college-only") {
        const collectionResults = findCollectionResults(query);

        if (collectionResults.length === 1) {
          window.location.href = collectionResults[0].url;
          return;
        }

        if (collectionResults.length > 1) {
          goToSearchPage(query);
          return;
        }
      }

      goToSearchPage(query);
    };

    input.addEventListener("input", function () {
      activeIndex = -1;
      renderAutocomplete(this.value.trim());
    });

    input.addEventListener("keydown", function (event) {
      const items = wrapper.querySelectorAll(".collection-item");

      if (event.key === "ArrowDown" || event.keyCode === 40) {
        event.preventDefault();

        if (!items.length) return;

        activeIndex++;
        if (activeIndex >= items.length) activeIndex = 0;

        items.forEach((item) => item.classList.remove("autocomplete-active"));
        items[activeIndex].classList.add("autocomplete-active");
      } else if (event.key === "ArrowUp" || event.keyCode === 38) {
        event.preventDefault();

        if (!items.length) return;

        activeIndex--;
        if (activeIndex < 0) activeIndex = items.length - 1;

        items.forEach((item) => item.classList.remove("autocomplete-active"));
        items[activeIndex].classList.add("autocomplete-active");
      } else if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault();

        if (activeIndex > -1 && items[activeIndex]) {
          items[activeIndex].click();
          return;
        }

        handleSearchSubmit(input.value);
      }
    });

    if (button) {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        handleSearchSubmit(input.value);
      });
    }

    document.addEventListener("click", function (event) {
      if (!wrapper.contains(event.target)) clearAutocomplete();
    });
  });

  const closeButton = document.getElementById("NewSearchClose");
  const drawer = document.getElementById("NewSearchDrawer");

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      drawer?.classList.remove("open-search-drawer");
      document.body.classList.remove("js-drawer-open-right");
    });
  }
});